export default {
  USER_ACCREDITATION_REQUESTED: 'USER_ACCREDITATION_REQUESTED',
  USER_ACCREDITATION_SUCCEEDED: 'USER_ACCREDITATION_SUCCEEDED',
  USER_ACCREDITATION_FAILED: 'USER_ACCREDITATION_FAILED',
};
